<div class="container-loader" *ngIf="stepProcess === 'LOADING' || (stepProcess === 'PROCESS' && !flujoCargado)">
  <i class="pi pi-spin pi-spinner"></i>
  <p>Estamos buscando tu solicitud...</p>
</div>
<ng-container *ngIf="stepProcess === 'PROCESS' && flujoCargado">
  <div class="container-screen">
    <app-app-navigation-header
      [title]="titleSection"
      [backRoute]="screenVerificationList ? '' : backRoute"
      (onClick)="showVerificationScreen($event)"
    ></app-app-navigation-header>
    <div class="grid" style="max-width: 100%; margin: auto;">
      <div class="col-12 main-container-info">
        <ng-container *ngIf="screenVerificationList; else elseVerificationList">
          <section class="lx-pagina" lang="es" [attr.aria-busy]="cargandoPasos ? 'true' : null">
            <ng-container *ngIf="data || flowStatus; else sinDatos">
              <app-progress-verification [data]="data" [flowStatus]="flowStatus"></app-progress-verification>

              <ng-container *ngIf="isStatusBeyondDocuments(); else elseNotInVerification">
                <!-- Estados finales: qué pasó, qué sigue y la línea de tiempo -->
                <section class="lx-tarjeta lx-tarjeta--elevada lx-a-final" *ngIf="estadoFinal as final" aria-labelledby="lx-a-final-titulo">
                  <div class="lx-a-final__portada">
                    <div class="lx-celebracion__check" *ngIf="final.exito; else ilustracionFinal" aria-hidden="true">
                      <svg class="lx-check" viewBox="0 0 52 52">
                        <circle class="lx-check__circulo" cx="26" cy="26" r="25"></circle>
                        <path class="lx-check__trazo" d="M15 27.5l7 7 15-16"></path>
                      </svg>
                    </div>
                    <ng-template #ilustracionFinal>
                      <div class="lx-halo" aria-hidden="true"><fa-icon [icon]="final.icono"></fa-icon></div>
                    </ng-template>
                    <span class="lx-chip" [ngClass]="estados[final.chip].chip">
                      <fa-icon *ngIf="estados[final.chip].icono as icono" [icon]="icono" aria-hidden="true"></fa-icon>{{final.chipTexto}}
                    </span>
                    <h3 class="lx-a-final__titulo" id="lx-a-final-titulo">{{final.titulo}}</h3>
                    <p class="lx-a-final__texto">{{final.texto}}</p>
                  </div>

                  <h4 class="lx-a-final__seccion" id="lx-a-linea-titulo">Así va tu solicitud</h4>
                  <ol class="lx-a-linea" aria-labelledby="lx-a-linea-titulo">
                    <li class="lx-a-linea__paso" *ngFor="let paso of final.linea" [ngClass]="estados[paso.estado].paso">
                      <span class="lx-a-linea__marca" aria-hidden="true">
                        <fa-icon *ngIf="estados[paso.estado].icono as icono" [icon]="icono"></fa-icon>
                      </span>
                      <span class="lx-a-linea__textos">
                        <span class="lx-a-linea__titulo">{{paso.titulo}}</span>
                        <span class="lx-a-linea__texto">{{paso.texto}}</span>
                        <span class="lx-chip" [ngClass]="estados[paso.estado].chip">
                          <fa-icon *ngIf="estados[paso.estado].icono as icono" [icon]="icono" aria-hidden="true"></fa-icon>{{paso.chip}}
                        </span>
                      </span>
                    </li>
                  </ol>

                  <div class="lx-alerta" [ngClass]="final.notaTipo === 'exito' ? 'lx-alerta--exito' : 'lx-alerta--info'" *ngIf="final.nota">
                    <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="final.notaTipo === 'exito' ? iconos.listo : iconos.info"></fa-icon></span>
                    <p class="lx-alerta__texto lx-alerta__cuerpo">{{final.nota}}</p>
                  </div>
                </section>
              </ng-container>
              <ng-template #elseNotInVerification>
                <app-verification-documents-list *ngIf="data; else pasosSinDatos" [data]="data" (onClick)="showScreen($event)"></app-verification-documents-list>
                <ng-template #pasosSinDatos>
                  <ng-container *ngTemplateOutlet="cargandoPasos ? esqueletoPasos : errorPasos"></ng-container>
                </ng-template>
              </ng-template>
            </ng-container>

            <!-- Aún no llega nada: esqueletos mientras carga, aviso si falló -->
            <ng-template #sinDatos>
              <ng-container *ngIf="cargandoPasos; else errorPasos">
                <div class="lx-hero lx-a-esqueleto-hero" aria-hidden="true">
                  <div class="lx-hero__cabeza">
                    <span class="lx-esqueleto lx-esqueleto--icono"></span>
                    <span class="lx-a-esqueleto-hero__textos">
                      <span class="lx-esqueleto lx-esqueleto--corto"></span>
                      <span class="lx-esqueleto lx-esqueleto--titulo"></span>
                      <span class="lx-esqueleto"></span>
                    </span>
                  </div>
                  <span class="lx-esqueleto lx-a-esqueleto-hero__barra"></span>
                </div>
                <ng-container *ngTemplateOutlet="esqueletoPasos"></ng-container>
              </ng-container>
            </ng-template>

            <ng-template #esqueletoPasos>
              <div class="lx-pila lx-pila--chica" aria-hidden="true">
                <div class="lx-esqueleto lx-esqueleto--bloque lx-a-esqueleto-siguiente"></div>
                <div class="lx-esqueleto-paso" *ngFor="let fantasma of [1, 2, 3, 4]">
                  <span class="lx-esqueleto lx-esqueleto--icono"></span>
                  <span class="lx-esqueleto-paso__textos">
                    <span class="lx-esqueleto lx-esqueleto--titulo"></span>
                    <span class="lx-esqueleto lx-esqueleto--corto"></span>
                  </span>
                </div>
              </div>
              <p class="lx-sr" role="status">Cargando tus pasos…</p>
            </ng-template>

            <ng-template #errorPasos>
              <div class="lx-vacio" role="alert">
                <span class="lx-vacio__icono lx-a-vacio__icono--error" aria-hidden="true"><fa-icon [icon]="iconos.reenviar"></fa-icon></span>
                <h2 class="lx-vacio__titulo">No pudimos cargar tus pasos</h2>
                <p class="lx-vacio__texto">Revisa tu conexión e inténtalo de nuevo. Tu avance no se pierde.</p>
                <button type="button" class="lx-btn lx-btn--primario" (click)="retryFlow()">
                  <fa-icon [icon]="iconos.reenviar" aria-hidden="true"></fa-icon><span>Reintentar</span>
                </button>
              </div>
            </ng-template>
          </section>
        </ng-container>
        <ng-template #elseVerificationList>
          <ng-container [ngSwitch]="currentScreenType">
            <app-form-component *ngSwitchCase="'FORM'" [data]="currentScreenData" [pushingId]="flowStatus?.pushingId ?? ''" (onEndProcess)="showVerificationScreen($event)"></app-form-component>
            <app-account-validation-component *ngSwitchCase="'DRUO'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-account-validation-component>
            <app-document-component *ngSwitchCase="'DOCUMENT'" [data]="currentScreenData" [pushingId]="flowStatus?.pushingId ?? ''" (onEndProcess)="showVerificationScreen($event)" (onUpdateStage)="retryFlow()"></app-document-component>
            <app-ine-validation *ngSwitchCase="'INCODE'" [data]="currentScreenData" [pushingId]="flowStatus?.pushingId ?? ''" (onEndProcess)="showVerificationScreen($event)" (onUpdateStage)="retryFlow()"></app-ine-validation>
            <app-sign-document *ngSwitchCase="'WEETRUST'" [data]="currentScreenData" [pushingId]="flowStatus?.pushingId ?? ''" (onEndProcess)="showVerificationScreen($event)"></app-sign-document>
            <app-offer-component *ngSwitchCase="'OFFER'" [data]="currentScreenData" [pushingId]="flowStatus?.pushingId ?? ''" (onEndProcess)="showVerificationScreen($event)"></app-offer-component>
            <app-manual-validation-component *ngSwitchCase="'MANUAL'" [data]="currentScreenData" (onEndProcess)="showVerificationScreen($event)"></app-manual-validation-component>
            <app-videoselfie-component *ngSwitchCase="'VIDEO'"  [data]="currentScreenData" [pushingId]="flowStatus?.pushingId ?? ''" (onEndProcess)="showVerificationScreen($event)"></app-videoselfie-component>
            <app-external-component *ngSwitchDefault [data]="currentScreenData" [pushingId]="flowStatus?.pushingId ?? ''" (onEndProcess)="showVerificationScreen($event)"></app-external-component>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
</ng-container>

<!-- Entrada: datos → código por SMS -->
<ng-container *ngIf="stepProcess === 'RFC'">
  <div class="container-screen">
    <app-app-navigation-header [title]="'Inicia tu solicitud'"></app-app-navigation-header>
    <div class="grid" style="max-width: 100%; margin: auto;">
      <div class="col-12 main-container-info">
        <section class="lx-pagina lx-pagina--con-cta lx-a-entrada" lang="es">
          <header class="lx-hero">
            <img class="lx-a-entrada__logo" src="/assets/media/images/logo/main.png" alt="Pulpi" width="120" height="21">
            <div class="lx-hero__cabeza">
              <span class="lx-hero__icono" aria-hidden="true"><fa-icon [icon]="codeSent ? iconos.sms : iconos.usuario"></fa-icon></span>
              <div class="lx-hero__textos">
                <span class="lx-hero__eyebrow">Tu solicitud</span>
                <h2 class="lx-hero__titulo">{{!codeSent ? 'Empecemos con tus datos' : (isPhoneVerified ? '¡Qué bueno verte de nuevo!' : 'Confirma que eres tú')}}</h2>
                <p class="lx-hero__subtitulo" *ngIf="!codeSent">Con ellos encontramos tu solicitud y te mandamos un código para confirmar tu teléfono.</p>
                <p class="lx-hero__subtitulo" *ngIf="codeSent && !isPhoneVerified">Escribe el código que te mandamos por SMS al {{telefonoOculto}}.</p>
                <p class="lx-hero__subtitulo" *ngIf="codeSent && isPhoneVerified">Tienes una solicitud en curso.</p>
              </div>
            </div>
            <div class="lx-hero__pie">
              <ol class="lx-etapas" [attr.aria-label]="'Parte ' + (codeSent ? 2 : 1) + ' de 2'">
                <li [class.is-listo]="codeSent" [class.is-actual]="!codeSent" [attr.aria-current]="!codeSent ? 'step' : null">
                  <span class="lx-etapas__barra" aria-hidden="true"></span>
                  <span class="lx-etapas__texto"><span class="lx-etapas__marca" aria-hidden="true"><fa-icon *ngIf="codeSent; else parteUno" [icon]="iconos.listo"></fa-icon><ng-template #parteUno>1</ng-template></span>Tus datos</span>
                </li>
                <li [class.is-actual]="codeSent" [attr.aria-current]="codeSent ? 'step' : null">
                  <span class="lx-etapas__barra" aria-hidden="true"></span>
                  <span class="lx-etapas__texto"><span class="lx-etapas__marca" aria-hidden="true">2</span>Código por SMS</span>
                </li>
              </ol>
            </div>
          </header>

          <form class="lx-tarjeta" id="lx-a-entrada-form" [formGroup]="entity" (ngSubmit)="enviarFormulario()" novalidate>
            <div class="lx-form">
              <ng-container *ngIf="!codeSent || editandoDatos; else resumenDatos">
                <fieldset class="lx-grupo">
                  <legend class="lx-grupo__titulo"><fa-icon [icon]="iconos.rfc" aria-hidden="true"></fa-icon>Tus datos</legend>
                  <div class="lx-campo" [class.is-invalido]="invalido('rfc')">
                    <label class="lx-campo__etiqueta" for="rfc">RFC</label>
                    <input class="lx-control lx-a-mayusculas" id="rfc" type="text" formControlName="rfc" placeholder="GODE561231GR8"
                           maxlength="13" autocomplete="off" autocapitalize="characters" autocorrect="off" spellcheck="false"
                           [attr.aria-invalid]="invalido('rfc')" aria-describedby="rfc-pie" (input)="alEscribirRfc($event)">
                    <div class="lx-campo__pie" id="rfc-pie">
                      <ng-container *ngIf="invalido('rfc'); else ayudaRfc">
                        <p class="lx-campo__error" *ngIf="entity.get('rfc')?.errors?.['required']"><fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon>Escribe tu RFC.</p>
                        <p class="lx-campo__error" *ngIf="entity.get('rfc')?.errors?.['pattern']"><fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon>Revísalo: son 4 letras, tu fecha de nacimiento (AAMMDD) y 3 de homoclave.</p>
                      </ng-container>
                      <ng-template #ayudaRfc><p class="lx-campo__ayuda">Con él encontramos tu solicitud. Lo ves en tu recibo de nómina.</p></ng-template>
                      <span class="lx-campo__contador" aria-hidden="true">{{longitudRfc}}/13</span>
                    </div>
                  </div>
                </fieldset>

                <fieldset class="lx-grupo">
                  <legend class="lx-grupo__titulo"><fa-icon [icon]="iconos.correo" aria-hidden="true"></fa-icon>Cómo te contactamos</legend>
                  <div class="lx-campo" [class.is-invalido]="invalido('emailAddress')">
                    <label class="lx-campo__etiqueta" for="emailAddress">Correo electrónico</label>
                    <input class="lx-control" id="emailAddress" type="email" inputmode="email" formControlName="emailAddress" placeholder="nombre@correo.com"
                           autocomplete="email" autocapitalize="off" autocorrect="off" spellcheck="false"
                           [attr.aria-invalid]="invalido('emailAddress')" aria-describedby="emailAddress-pie" (blur)="alSalirCorreo()">
                    <div id="emailAddress-pie">
                      <ng-container *ngIf="invalido('emailAddress'); else ayudaCorreo">
                        <p class="lx-campo__error" *ngIf="entity.get('emailAddress')?.errors?.['required']"><fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon>Escribe tu correo.</p>
                        <p class="lx-campo__error" *ngIf="entity.get('emailAddress')?.errors?.['pattern']"><fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon>Revísalo: debe verse como nombre&#64;correo.com.</p>
                      </ng-container>
                      <ng-template #ayudaCorreo><p class="lx-campo__ayuda">Ahí te mandamos tu contrato y los avisos de tu solicitud.</p></ng-template>
                    </div>
                  </div>

                  <div class="lx-campo" [class.is-invalido]="invalido('phoneNumber')">
                    <label class="lx-campo__etiqueta" for="phoneNumber">Teléfono celular</label>
                    <p-inputMask inputId="phoneNumber" formControlName="phoneNumber" mask="99 9999 9999" [unmask]="true" [autoClear]="false"
                                 type="tel" autocomplete="tel-national" placeholder="55 1234 5678"></p-inputMask>
                    <div>
                      <ng-container *ngIf="invalido('phoneNumber'); else ayudaTelefono">
                        <p class="lx-campo__error" *ngIf="entity.get('phoneNumber')?.errors?.['required']"><fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon>Escribe tu número de celular.</p>
                        <p class="lx-campo__error" *ngIf="entity.get('phoneNumber')?.errors?.['pattern']"><fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon>Escribe los 10 dígitos, sin +52.</p>
                      </ng-container>
                      <ng-template #ayudaTelefono><p class="lx-campo__ayuda">Te mandamos un código por SMS para confirmar que es tuyo.</p></ng-template>
                    </div>
                  </div>

                  <div class="lx-campo" [class.is-invalido]="invalido('secondPhoneNumber')">
                    <label class="lx-campo__etiqueta" for="secondPhoneNumber">Otro teléfono <span class="lx-campo__opcional">(opcional)</span></label>
                    <p-inputMask inputId="secondPhoneNumber" formControlName="secondPhoneNumber" mask="99 9999 9999" [unmask]="true" [autoClear]="false"
                                 type="tel" autocomplete="off" placeholder="55 1234 5678"></p-inputMask>
                    <div>
                      <p class="lx-campo__error" *ngIf="invalido('secondPhoneNumber'); else ayudaSegundo"><fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon>Escribe los 10 dígitos o déjalo vacío.</p>
                      <ng-template #ayudaSegundo><p class="lx-campo__ayuda">Por si no logramos localizarte en el primero.</p></ng-template>
                    </div>
                  </div>

                  <div class="lx-alerta lx-alerta--info">
                    <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.info"></fa-icon></span>
                    <div class="lx-alerta__cuerpo">
                      <p class="lx-alerta__titulo">Usa teléfonos personales</p>
                      <p class="lx-alerta__texto">No pongas teléfonos de tu trabajo o de la empresa.</p>
                    </div>
                  </div>
                </fieldset>
              </ng-container>

              <!-- Con el código enviado: los datos quedan como resumen -->
              <ng-template #resumenDatos>
                <div class="lx-grupo">
                  <div class="lx-a-resumen-datos__cabeza">
                    <p class="lx-grupo__titulo"><fa-icon [icon]="iconos.rfc" aria-hidden="true"></fa-icon>Tus datos</p>
                    <button type="button" class="lx-enlace" (click)="editandoDatos = true">
                      <fa-icon [icon]="iconos.editar" aria-hidden="true"></fa-icon><span>Editar<span class="lx-sr"> mis datos</span></span>
                    </button>
                  </div>
                  <dl class="lx-datos">
                    <div class="lx-dato"><dt class="lx-dato__etiqueta">RFC</dt><dd class="lx-dato__valor">{{entity.get('rfc')?.value}}</dd></div>
                    <div class="lx-dato"><dt class="lx-dato__etiqueta">Correo</dt><dd class="lx-dato__valor">{{entity.get('emailAddress')?.value}}</dd></div>
                    <div class="lx-dato"><dt class="lx-dato__etiqueta">Celular</dt><dd class="lx-dato__valor">{{telefonoOculto}}</dd></div>
                  </dl>
                </div>
              </ng-template>

              <div class="lx-alerta lx-alerta--exito" *ngIf="codeSent && isPhoneVerified" role="status">
                <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.listo"></fa-icon></span>
                <div class="lx-alerta__cuerpo">
                  <p class="lx-alerta__titulo">Ya confirmamos tu teléfono</p>
                  <p class="lx-alerta__texto">Sigue con tu solicitud donde te quedaste o empieza una nueva.</p>
                </div>
              </div>

              <fieldset class="lx-grupo" *ngIf="codeSent && !isPhoneVerified">
                <legend class="lx-grupo__titulo"><fa-icon [icon]="iconos.sms" aria-hidden="true"></fa-icon>Código de verificación</legend>
                <div class="lx-campo" [class.is-invalido]="intentoCodigo && codigoVacio">
                  <label class="lx-campo__etiqueta" for="code">Código que te llegó por SMS</label>
                  <input class="lx-control lx-a-codigo" id="code" type="text" formControlName="code" placeholder="Ej. a1B2c3"
                         autocomplete="one-time-code" autocapitalize="off" autocorrect="off" spellcheck="false"
                         [attr.aria-invalid]="intentoCodigo && codigoVacio" aria-describedby="code-pie" (input)="alEscribirCodigo($event)">
                  <div id="code-pie">
                    <p class="lx-campo__error" *ngIf="intentoCodigo && codigoVacio; else ayudaCodigo"><fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon>Escribe el código de 6 caracteres que te llegó por SMS.</p>
                    <ng-template #ayudaCodigo><p class="lx-campo__ayuda">Son 6 caracteres; respeta mayúsculas y minúsculas.</p></ng-template>
                  </div>
                </div>

                <div class="lx-a-reenvio">
                  <ng-container *ngIf="timer > 0 && !isPhoneVerified; else elseTimer">
                    <span class="lx-a-reenvio__texto"><fa-icon [icon]="iconos.reloj" aria-hidden="true"></fa-icon>Pide otro código en <strong class="lx-a-reenvio__tiempo">{{getFormattedTimer()}}</strong></span>
                  </ng-container>
                  <ng-template #elseTimer>
                    <span class="lx-a-reenvio__texto">¿No te llegó?</span>
                    <button type="button" class="lx-enlace" (click)="enviarCodigo()">
                      <fa-icon [icon]="iconos.reenviar" aria-hidden="true"></fa-icon><span>Reenviar código</span>
                    </button>
                  </ng-template>
                </div>
              </fieldset>

              <!-- Respuesta del servidor, en la misma tarjeta -->
              <div class="lx-alerta" *ngIf="avisoEntrada as aviso" [ngClass]="aviso.tipo === 'error' ? 'lx-alerta--error' : 'lx-alerta--exito'"
                   [attr.role]="aviso.tipo === 'error' ? 'alert' : 'status'">
                <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="aviso.tipo === 'error' ? iconos.error : iconos.listo"></fa-icon></span>
                <div class="lx-alerta__cuerpo">
                  <p class="lx-alerta__titulo">{{aviso.titulo}}</p>
                  <p class="lx-alerta__texto" *ngIf="aviso.texto">{{aviso.texto}}</p>
                </div>
                <button type="button" class="lx-alerta__cerrar" aria-label="Cerrar aviso" (click)="cerrarAviso()"><fa-icon [icon]="iconos.cerrar"></fa-icon></button>
              </div>
            </div>

            <div class="lx-cta" *ngIf="codeSent && isPhoneVerified">
              <button type="button" class="lx-btn lx-btn--secundario" (click)="startNewProcess()"><span>Empezar una solicitud nueva</span></button>
            </div>
          </form>

          <p class="lx-seguro">
            <span class="lx-seguro__icono" aria-hidden="true"><fa-icon [icon]="iconos.seguro"></fa-icon></span>
            <span>Tus datos viajan cifrados y solo los usamos para tu solicitud.</span>
          </p>
        </section>

        <!-- Acción principal, siempre a la mano (el formulario es largo) -->
        <div class="lx-cta-fijo">
          <button *ngIf="!codeSent" type="submit" form="lx-a-entrada-form" class="lx-btn lx-btn--primario">
            <fa-icon [icon]="iconos.sms" aria-hidden="true"></fa-icon><span>Enviarme el código por SMS</span>
          </button>
          <ng-container *ngIf="codeSent">
            <button *ngIf="!isPhoneVerified" type="submit" form="lx-a-entrada-form" class="lx-btn lx-btn--primario"><span>Verificar código</span></button>
            <button *ngIf="isPhoneVerified" type="submit" form="lx-a-entrada-form" class="lx-btn lx-btn--primario">
              <span>Continuar con mi solicitud</span><fa-icon [icon]="iconos.flecha" aria-hidden="true"></fa-icon>
            </button>
          </ng-container>
          <p class="lx-cta-fijo__nota">{{!codeSent ? 'Te llega un SMS en unos segundos.' : (isPhoneVerified ? 'Retomas donde te quedaste.' : 'Así confirmamos que el celular es tuyo.')}}</p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
